import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var QrCode = createReactComponent("QrCode", ["svg", defaultAttributes, [["rect", {
  x: "2",
  y: "2",
  width: "8",
  height: "8",
  key: "ctxgbq"
}], ["path", {
  d: "M6 6h.01",
  key: "1wio8d"
}], ["rect", {
  x: "14",
  y: "2",
  width: "8",
  height: "8",
  key: "1re0wi"
}], ["path", {
  d: "M18 6h.01",
  key: "qrgi8k"
}], ["rect", {
  x: "2",
  y: "14",
  width: "8",
  height: "8",
  key: "9t1ey9"
}], ["path", {
  d: "M6 18h.01",
  key: "1t0lit"
}], ["path", {
  d: "M14 14h.01",
  key: "h7lxmz"
}], ["path", {
  d: "M18 18h.01",
  key: "191fmy"
}], ["path", {
  d: "M18 22h4v-4",
  key: "1fna9d"
}], ["path", {
  d: "M14 18v4",
  key: "imfp0i"
}], ["path", {
  d: "M22 14h-4",
  key: "fdt8m0"
}]]]);
export default QrCode;